import type { LanguageApi } from 'api-typings/translations/translations_types';
import type { ActiveLanguage } from './active-languages.model';

export function transformLanguage(language: LanguageApi): ActiveLanguage {
  return {
    id: language.code,
    code: language.code,
    name: language.language,
    englishName: language.english_name,
  };
}
